/* !
 * setting.js v1.0.0
 * Copyright, Connecty Inc.
 */
(() => {
	const siteName = 'default-package';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 90,
				sp: 60
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					// 置換完了時にカスタムイベントを発火
					document.dispatchEvent(new Event('localincludeLoaded'));

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);

					document.dispatchEvent(new Event('localincludeLoaded'));
					_this.loadDelayScript();
				});
			} else {
				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		accordion() {
			const details = document.querySelectorAll('.js-accordion');

			details.forEach(ele => {
				const summary = ele.querySelector('summary');
				if (!summary) return; // summary要素がない場合はスキップ
				const wrapper = ele.querySelector('.mod-accordion-wrapper');
				const plus = ele.querySelector('.mod-accordion-plus');
				summary.addEventListener('click', e => {
					e.preventDefault();
					if (ele.open) {
						const close = wrapper.animate(
							{
								opacity: [1, 0],
								height: [wrapper.offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['90deg', '0deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
						close.onfinish = () => {
							ele.removeAttribute('open');
						}
					} else {
						ele.setAttribute('open', 'true');
						wrapper.animate(
							{
								opacity: [0, 1],
								height: [0, wrapper.offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
							}
						);
						plus.animate(
							{ rotate: ['0deg', '90deg'] },
							{
								duration: 300,
								pseudoElement: "::after",
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
				});
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							$(ele).addClass(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}

				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(ele2 => { ele2.classList.remove(a); })
						ele.classList.add(a);
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			// ページロード後の初回スクロールかどうかを判定
			let isFirstScroll = true;

			// swingイージング関数
			const easeOutSwing = (t) => {
				return 0.5 - Math.cos(t * Math.PI) / 2;
			};

			// 手動スクロールアニメーション（swingイージング）
			const animateScroll = (to, duration) => {
				return new Promise((resolve) => {
					const start = window.scrollY;
					const change = to - start;
					const startTime = performance.now();

					const animate = (currentTime) => {
						const elapsed = currentTime - startTime;
						const progress = Math.min(elapsed / duration, 1);
						const eased = easeOutSwing(progress);

						window.scrollTo(0, start + change * eased);

						if (progress < 1) {
							requestAnimationFrame(animate);
						} else {
							resolve();
						}
					};

					requestAnimationFrame(animate);
				});
			};

			const scrollToObject = async (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let targetElement = hash === 'pagetop' ? null : document.getElementById(hash);
				let pos = hash === 'pagetop' ? 0 : targetElement.getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}

				if (isFirstScroll) {
					// 初回はswingイージング（600ms）
					await animateScroll(pos, 600);

					// lazy-loaded画像などによる位置ずれを補正
					if (hash !== 'pagetop' && targetElement) {
						let isAdjusting = true;
						let lastAdjustTime = Date.now();

						const headerHeight = FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp
							? FUNCTIONS.va.header.sp
							: FUNCTIONS.va.header.desktop;

						// ユーザーの手動スクロールで補正を停止
						const stopAdjustment = () => { isAdjusting = false; };
						window.addEventListener('wheel', stopAdjustment, { once: true, passive: true });
						window.addEventListener('touchstart', stopAdjustment, { once: true, passive: true });
						window.addEventListener('touchmove', stopAdjustment, { once: true, passive: true });

						const adjustScroll = () => {
							if (!isAdjusting) return;
							const elementTop = targetElement.getBoundingClientRect().top;
							const targetPosition = window.scrollY + elementTop - headerHeight;
							const diff = Math.abs(window.scrollY - targetPosition);
							if (diff > 5) {
								window.scrollTo({ top: targetPosition, behavior: 'smooth' });
								lastAdjustTime = Date.now();
							}
						};

						// 位置ずれを定期的に監視・補正
						const scrollMonitor = setInterval(() => {
							if (!isAdjusting) {
								clearInterval(scrollMonitor);
								return;
							}
							adjustScroll();
							if (Date.now() - lastAdjustTime > 500) {
								isAdjusting = false;
								clearInterval(scrollMonitor);
							}
						}, 100);

						// 最大3秒で強制終了
						setTimeout(() => {
							isAdjusting = false;
							clearInterval(scrollMonitor);
						}, 3000);
					}

					isFirstScroll = false;
				} else {
					// 2回目以降は通常のスムーススクロール
					window.scrollTo({ top: pos, behavior: 'smooth' });
				}
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if(focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
				return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
						resolve(true);
					}, 100);
					const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			};
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						await scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];
						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				// フォーカス用関数
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						const focusableElements = Array.from(
							document.getElementById(hash).querySelectorAll(focusableElementsSelector)
						);
						if(focusableElements.length) {
							focusableElements[0].focus();
						}
					}
				}
				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
						resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}
				// load済みなら即実行、未了ならイベント待ち
			const onLoad = async () => {
					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';

					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';

						const targetId = hash.split('#')[1];
						const targetElement = document.getElementById(targetId);
						if (!targetElement) return;

						let pos = targetElement.getBoundingClientRect().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= FUNCTIONS.va.header.sp;
						} else {
							pos -= FUNCTIONS.va.header.desktop;
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });

						// lazy-loaded画像などによる位置ずれを補正
						let isAdjusting = true;
						let lastAdjustTime = Date.now();

						const headerHeight = FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp
							? FUNCTIONS.va.header.sp
							: FUNCTIONS.va.header.desktop;

						// ユーザーの手動スクロールで補正を停止
						const stopAdjustment = () => { isAdjusting = false; };
						window.addEventListener('wheel', stopAdjustment, { once: true, passive: true });
						window.addEventListener('touchstart', stopAdjustment, { once: true, passive: true });
						window.addEventListener('touchmove', stopAdjustment, { once: true, passive: true });

						const adjustScroll = () => {
							if (!isAdjusting) return;
							const elementTop = targetElement.getBoundingClientRect().top;
							const targetPosition = window.scrollY + elementTop - headerHeight;
							const diff = Math.abs(window.scrollY - targetPosition);
							if (diff > 5) {
								window.scrollTo({ top: targetPosition, behavior: 'smooth' });
								lastAdjustTime = Date.now();
							}
						};

						// 位置ずれを定期的に監視・補正
						const scrollMonitor = setInterval(() => {
							if (!isAdjusting) {
								clearInterval(scrollMonitor);
								return;
							}
							adjustScroll();
							if (Date.now() - lastAdjustTime > 500) {
								isAdjusting = false;
								clearInterval(scrollMonitor);
							}
						}, 100);

						// 最大3秒で強制終了
						setTimeout(() => {
							isAdjusting = false;
							clearInterval(scrollMonitor);
						}, 3000);
					}, 100);
					await waitForScrollComplete(hash);
				};
				if (document.readyState === 'complete') {
					onLoad();
				} else {
					window.addEventListener('load', onLoad);
				}
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}
				});
			}
		},
		setModal() {
			const createModal = (_appendHTML,_target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener('keydown', function (event) {
						if(document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === 'Tab') {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
								document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
								} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
								}
							}
							// ESCキーが押された時
							if (event.key === 'Escape') {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content) {
						let closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						let closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						let containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML,e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const _this = this;
			const $elements = document.querySelectorAll('[data-mh]');
			if ( !$elements.length ) return;

			// 自分自身の更新中はResizeObserverの再帰トリガーを抑制
			_this._matchHeightRunning = true;

			const groups = new Map();

			$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化

			$elements.forEach( ele => {
				const attributeName = ele.getAttribute('data-mh');
				if ( !groups.has( attributeName ) ) {
					groups.set( attributeName, [] );
				}
				groups.get( attributeName ).push( ele );
			} );
			groups.forEach( group => {
				const attributeGroups = new Map();
				group.forEach( ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;
					const key = attributeName + '_' + topPosition;
					if ( !attributeGroups.has( key ) ) {
						attributeGroups.set( key, [] );
					}
					attributeGroups.get( key ).push( ele );
				} );
				attributeGroups.forEach( (item) => {
					const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
					item.forEach( (ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			} );

			// 初回のみ：画像読み込みやスライダー等の動的変化を監視して再実行
			if ( !_this._matchHeightObserver ) {
				let debounceTimer;
				const observer = new ResizeObserver( () => {
					if ( _this._matchHeightRunning ) return;
					clearTimeout( debounceTimer );
					debounceTimer = setTimeout( () => { _this.matchHeight(); }, 150 );
				} );
				$elements.forEach( ele => observer.observe( ele ) );
				_this._matchHeightObserver = observer;
			}

			// 描画後にフラグ解除（この間に発生したResizeObserver通知は自分自身の更新によるものなので無視）
			requestAnimationFrame( () => { _this._matchHeightRunning = false; } );
		},
		inViewAnimation() {
			const target = document.querySelectorAll('.js-fade');
			target.forEach(ele => ele.classList.add('is-animSet')); // JS OFF時用のclassを付与
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		nextToggle() {
			const switchElements = document.querySelectorAll('.js-toggle');

			switchElements.forEach(switchElement => {
				switchElement.addEventListener('click', e => {
					e.currentTarget.classList.toggle(a);

					let toggleBlock = e.currentTarget.nextElementSibling;
					toggleBlock.classList.toggle(a);
					if (toggleBlock.style.height) {
						toggleBlock.style.height = null;
						toggleBlock.style.visibility = 'hidden';
					} else {
						toggleBlock.style.height = toggleBlock.scrollHeight + 'px';
						toggleBlock.style.visibility = 'visible';
					}
				});
			});
		},
		moreView() {
			const $moreViewElements = document.querySelectorAll('.js-moreView-button');
			// 初期状態:親要素にis-activeを付与し、ラベルを設定
			$moreViewElements.forEach(ele => {
				const $wrap = ele.closest('.js-moreView');
				const $label = ele.querySelector('.js-moreView-label');
				if ($wrap) {
					$wrap.classList.add(a);
				}
				if ($label) {
					$label.textContent = 'もっと見る';
				}
			});
			// クリックイベント(トグル)
			$moreViewElements.forEach(ele => {
				ele.addEventListener('click', (e) => {
					e.preventDefault();
					const $wrap = ele.closest('.js-moreView');
					const $label = ele.querySelector('.js-moreView-label');
					// 親要素と自身のis-activeをトグル
					if ($wrap) {
						$wrap.classList.toggle(a);
					}
					ele.classList.toggle(a);
					// ラベルの切り替え
					if ($label) {
						if (ele.classList.contains(a)) {
							$label.textContent = '閉じる';
						} else {
							$label.textContent = 'もっと見る';
						}
					}
				});
			});
		},
		imgZoom() {
			const elements = document.querySelectorAll('.js-imgZoom');
			if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.desktop) {
				elements.forEach(ele => {
					let initialDistance = 0;
					const getDistance = (touches) => {
						const dx = touches[0].clientX - touches[1].clientX;
						const dy = touches[0].clientY - touches[1].clientY;
						return Math.sqrt(dx * dx + dy * dy);
					};
					ele.addEventListener('touchstart', (e) => {
						if (e.touches.length === 2) {
							initialDistance = getDistance(e.touches);
						}
					});
					ele.addEventListener('touchmove', (e) => {
						if (e.touches.length === 2) {
							const currentDistance = getDistance(e.touches);
							// ピンチ操作が検出された場合
							if (Math.abs(currentDistance - initialDistance) > 10) {
								const modImgZooms = ele.querySelectorAll('.mod-imgZoom');
								modImgZooms.forEach(img => img.remove());
							}
						}
					});
				});
			}
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			}
			if(document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.textContent = bytesToSize(pdfElement.textContent);
				});
			}
		},
		removeElmIfEmpty() {
			// ＜ルート設定対応＞要素が空だったら削除
			const $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty () {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			const $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li').length) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		URLcurrent() {
			if (document.querySelector('.js-current')) {
				document.querySelectorAll('.js-current').forEach(item1 => {
					// 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
					const linkPath = new URL(item1.getAttribute('href'), location.origin).pathname.replace(/index\.html$/, '');
					const currentPath = location.pathname.replace(/index\.html$/, '');
					// 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
					if (currentPath == linkPath) {
						item1.classList.add(a);
					}
				});
			}
		},
		pcHeaderMegamenu() {
			if (document.querySelectorAll('.js-header-nav-mega').length) {
				const $header = document.querySelector('.header');
				const $megabtn = document.querySelectorAll('.js-header-nav-mega-btn');
				const $megamenu = document.querySelectorAll('.js-header-nav-mega-contents');
				const $loginBtn = document.querySelector('.js-header-login-btn');
				const $loginContents = document.querySelector('.js-header-login-contents');
				const closeAllMegaMenus = () => {
					$header.classList.remove(a);
					$megabtn.forEach(btn => {
						btn.classList.remove(a);
						if (btn.nextElementSibling) {
							btn.nextElementSibling.classList.remove(a);
						}
					});
				};
				// メニューを開く共通関数
				const openMenu = (btn, menu) => {
					// ログインメニューが開いていたら閉じる
					if ($loginBtn) {
						$loginBtn.classList.remove(a);
					}
					if ($loginContents) {
						$loginContents.classList.remove(a);
					}
					// 他のメガメニューを閉じる
					$megabtn.forEach(otherBtn => {
						if (otherBtn !== btn) {
							otherBtn.classList.remove(a);
							if (otherBtn.nextElementSibling) {
								otherBtn.nextElementSibling.classList.remove(a);
							}
						}
					});
					// メニューを開く
					$header.classList.add(a);
					btn.classList.add(a);
					if (menu) {
						menu.classList.add(a);
					}
				};
				// メガメニューボタンのホバー・フォーカスイベント処理
				$megabtn.forEach(btn => {
					const menu = btn.nextElementSibling;
					// マウスオーバーでメニューを開く
					btn.addEventListener('mouseenter', () => {
						openMenu(btn, menu);
					});
					// フォーカス時にもメニューを開く
					btn.addEventListener('focus', () => {
						openMenu(btn, menu);
					});
					// メニュー全体からマウスが離れたら閉じる
					if (menu) {
						const handleMouseLeave = () => {
							$header.classList.remove(a);
							btn.classList.remove(a);
							menu.classList.remove(a);
						};
						menu.addEventListener('mouseleave', handleMouseLeave);
					}
				});
				// メガメニュー外のクリックで閉じる
				document.addEventListener('click', (event) => {
					const target = event.target;
					const isClickInsideNav = [...$megamenu]
						.some(el => el.contains(target));
					const isClickOnButton = [...$megabtn]
						.some(btn => btn.contains(target));
					if (!isClickInsideNav && !isClickOnButton && $header.classList.contains(a)) {
						closeAllMegaMenus();
					}
				});
				// フォーカスが外れた時のメニュー制御を追加
				$megabtn.forEach(btn => {
					const menu = btn.nextElementSibling;
					if (menu) {
						// フォーカスが .header-nav-pc 内にあるかチェックする関数
						const isInsideAnyHeaderNav = (element) => {
							return Array.from($megamenu).some(headerNav => headerNav.contains(element));
						};
						// ボタンとメニュー両方のフォーカスアウトを監視
						const checkAndCloseMenu = () => {
							setTimeout(() => {
								const focusedElement = document.activeElement;
								const isInsideNav = menu.contains(focusedElement);
								const isInsideButton = btn.contains(focusedElement);
								const isInsideAnyBtn = Array.from($megabtn).some(b => b.contains(focusedElement));
								const isInsideHeaderNav = isInsideAnyHeaderNav(focusedElement);
								const isInsideLoginBtn = $loginBtn && $loginBtn.contains(focusedElement);
								const isInsideLoginContents = $loginContents && $loginContents.contains(focusedElement);
								// ログインメニュー内にフォーカスがある場合は閉じない
								if (isInsideLoginBtn || isInsideLoginContents) {
									return;
								}
								// ボタンやメニュー内にフォーカスがない場合に閉じる
								if (!isInsideNav && !isInsideButton && !isInsideAnyBtn && !isInsideHeaderNav) {
									closeAllMegaMenus();
								}
							}, 0);
						};
						btn.addEventListener('focusout', checkAndCloseMenu);
						menu.addEventListener('focusout', checkAndCloseMenu);
						// TabキーまたはShift+Tabで移動した際にメニューを閉じる
						document.addEventListener('keydown', (e) => {
							if (e.key === 'Tab') {
								setTimeout(() => {
									const focusedElement = document.activeElement;
									const isInsideNav = menu.contains(focusedElement);
									const isInsideButton = btn.contains(focusedElement);
									const isInsideAnyBtn = Array.from($megabtn).some(b => b.contains(focusedElement));
									const isInsideHeaderNav = isInsideAnyHeaderNav(focusedElement);
									const isInsideLoginBtn = $loginBtn && $loginBtn.contains(focusedElement);
									const isInsideLoginContents = $loginContents && $loginContents.contains(focusedElement);
									// ログインメニュー内にフォーカスがある場合は閉じない
									if (isInsideLoginBtn || isInsideLoginContents) {
										return;
									}
									// ボタンやメニュー内にフォーカスがない場合に閉じる
									if (!isInsideNav && !isInsideButton && !isInsideAnyBtn && !isInsideHeaderNav) {
										closeAllMegaMenus();
									}
								}, 0);
							}
						});
					}
				});
				// ESCキーでメガメニューを閉じる
				window.addEventListener('keydown', function (event) {
					if ($header.classList.contains(a)) {
						if (event.key === 'Escape') {
							event.preventDefault();
							closeAllMegaMenus();
						}
					}
				});
			}
		},
		spHeaderHamburger() {
			if (document.querySelectorAll('.js-header-hamburger').length) {
				const $header = document.querySelector('.header');
				const $hamburger = document.querySelector('.js-header-hamburger');
				const $nav = document.querySelector('.js-header-nav-sp');
				const $container = document.querySelector('.container') || document.querySelector('.legacy_container');
				let scrollTopNow;
				const fixedOnContainer = () => {
					if (!$container) return;
					scrollTopNow = window.scrollY;
					$container.style.position = 'fixed';
					$container.style.width = '100%';
					$container.style.top = -1 * scrollTopNow;
					$container.style.left = 0;
					const contents = $container.querySelector('.contents') || $container.querySelector('#legacy_contents');
					if (contents) contents.style.opacity = '0';
				};
				const fixedOffContainer = () => {
					if (!$container) return;
					$container.style.position = 'static';
					const contents = $container.querySelector('.contents') || $container.querySelector('#legacy_contents');
					if (contents) contents.style.opacity = '1';
					window.scrollTo({ top: scrollTopNow });
				};
				$hamburger.addEventListener('click', (e) => {
					if ($nav.classList.contains(a)) {
						$nav.classList.remove(a);
						$hamburger.classList.remove(a);
						$hamburger.ariaLabel = 'open'
						fixedOffContainer();
					} else {
						fixedOnContainer();
						$nav.classList.add(a);
						$hamburger.classList.add(a);
						$hamburger.ariaLabel = 'close'
					}
				});
				// SPナビ内のアコーディオン処理
				const $mainBtns = document.querySelectorAll('.js-header-nav-sp-main-btn');
				// メニューを開く共通関数
				const openMenu = (btn) => {
					const targetContents = btn.nextElementSibling;
					if (targetContents && targetContents.classList.contains('js-header-nav-sp--main-contents')) {
						// 初期状態を設定
						targetContents.style.display = 'block';
						targetContents.style.height = '0';
						targetContents.style.opacity = '0';
						targetContents.style.overflow = 'hidden';
						// 実際の高さを取得
						const height = targetContents.scrollHeight;
						// アニメーション実行
						targetContents.animate(
							{
								height: ['0px', height + 'px'],
								opacity: [0, 1]
							},
							{
								duration: 300,
								easing: 'ease'
							}
						).onfinish = () => {
							targetContents.style.height = 'auto';
							targetContents.style.opacity = '1';
							targetContents.style.overflow = 'visible';
						};
						btn.classList.add(a);
					}
				};
				// メニューを閉じる共通関数
				const closeMenu = (btn) => {
					const targetContents = btn.nextElementSibling;
					if (targetContents && targetContents.classList.contains('js-header-nav-sp--main-contents')) {
						// 現在の高さを取得
						const height = targetContents.scrollHeight;
						targetContents.style.height = height + 'px';
						targetContents.style.overflow = 'hidden';
						// アニメーション実行
						const closeAnimation = targetContents.animate(
							{
								height: [height + 'px', '0px'],
								opacity: [1, 0]
							},
							{
								duration: 300,
								easing: 'ease'
							}
						);
						closeAnimation.onfinish = () => {
							targetContents.style.display = 'none';
							targetContents.style.height = '';
							targetContents.style.opacity = '';
							targetContents.style.overflow = '';
						};
						btn.classList.remove(a);
					}
				};
				// 全てのメニューを閉じる関数
				const closeAllMenus = () => {
					$mainBtns.forEach(btn => closeMenu(btn));
				};
				$mainBtns.forEach(btn => {
					let isClickEvent = false;
					// クリックイベント
					btn.addEventListener('click', (e) => {
						isClickEvent = true;
						const targetBtn = e.currentTarget;
						if (targetBtn.classList.contains(a)) {
							closeMenu(targetBtn);
						} else {
							openMenu(targetBtn);
						}
						setTimeout(() => { isClickEvent = false; }, 100);
					});
				});
				// リサイズ時にPCレイアウトになったらメニューを閉じる
				let resizeTimer;
				window.addEventListener('resize', () => {
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(() => {
						const currentWidth = window.innerWidth;
						// PC表示になった時、SPメニューが開いていたら閉じる
						if (currentWidth >= FUNCTIONS.va.device.sp && $nav.classList.contains(a)) {
							$nav.classList.remove(a);
							$hamburger.classList.remove(a);
							$hamburger.ariaLabel = 'open';
							closeAllMenus();
							fixedOffContainer();
						}
					}, 200);
				});
				window.addEventListener('keydown', function (event) {
					if ($nav.classList.contains(a)) {
						// タブキーが押された時
						if (event.key === 'Tab') {
							event.preventDefault();
							// ヘッダー内のフォーカス可能な要素を取得（display: none の要素を除外）
							const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
							let focusableElements = Array.from($header.querySelectorAll(focusableElementsSelector))
								.filter(el => el.offsetParent !== null); // 非表示要素を除外
							if (focusableElements.length === 0) return;
							// 現在のフォーカス位置を取得
							const focusedItemIndex = focusableElements.indexOf(document.activeElement);
							console.log(focusedItemIndex, focusableElements);
							// shiftキーと同時に押されてた場合
							if (event.shiftKey) {
								if (focusedItemIndex === 0) {
									// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
									focusableElements[focusableElements.length - 1].focus();
								} else {
									// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
									focusableElements[focusedItemIndex - 1].focus();
								}
							} else {
								if (focusedItemIndex === focusableElements.length - 1) {
									// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
									focusableElements[0].focus();
								} else {
									// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
									focusableElements[focusedItemIndex + 1].focus();
								}
							}
						}
						// ESCキーが押された時
						if (event.key === 'Escape') {
							event.preventDefault();
							$nav.classList.remove(a);
							$hamburger.classList.remove(a);
							$hamburger.ariaLabel = 'close'
							fixedOffContainer();
							$hamburger.focus({ preventScroll: true });
						}
					}
				});
			}
		},
		headerLogin() {
			if (document.querySelectorAll('.js-header-login-btn').length) {
				const $header = document.querySelector('.header');
				const $loginBtn = document.querySelector('.js-header-login-btn');
				const $loginContents = document.querySelector('.js-header-login-contents');
				const $loginClose = document.querySelector('.js-header-login-close');
				const $megabtn = document.querySelectorAll('.js-header-nav-mega-btn');
				const $megamenu = document.querySelectorAll('.js-header-nav-mega-contents');
				const $nav = document.querySelector('.js-header-nav-sp');
				const $hamburger = document.querySelector('.js-header-hamburger');
				const $container = document.querySelector('.container');
				// メガメニューを閉じる処理（pcHeaderMegamenuと同じ）
				const closeMegaMenus = () => {
					$megabtn.forEach(btn => {
						btn.classList.remove(a);
						if (btn.nextElementSibling) {
							btn.nextElementSibling.classList.remove(a);
						}
					});
				};
				// SPナビを閉じる処理（spHeaderHamburgerと同じ）
				const closeSPNav = () => {
					if ($nav && $nav.classList.contains(a)) {
						// containerが固定されている場合は解除
						if ($container && $container.style.position === 'fixed') {
							const scrollTopNow = Math.abs(parseInt($container.style.top || '0', 10));
							$container.style.position = 'static';
							$container.querySelector('.contents').style.opacity = '1';
							window.scrollTo({ top: scrollTopNow });
						}
						$nav.classList.remove(a);
						if ($hamburger) {
							$hamburger.classList.remove(a);
							$hamburger.ariaLabel = 'open';
						}
					}
				};
				// ログインボタンをクリックで開閉
				$loginBtn.addEventListener('click', (e) => {
					e.stopPropagation();
					// メガメニューが開いていたら閉じる
					closeMegaMenus();
					// SPナビが開いていたら閉じる
					closeSPNav();
					// ログインボタンにis-activeがあったら閉じる処理
					if ($loginBtn.classList.contains(a)) {
						$header.classList.remove(a);
						$loginBtn.classList.remove(a);
						$loginContents.classList.remove(a);
					} else {
						// ログインボタンにis-activeがなかったら開く処理
						$header.classList.add(a);
						$loginBtn.classList.add(a);
						$loginContents.classList.add(a);
					}
				});
				// 閉じるボタンをクリックで閉じる
				if ($loginClose) {
					$loginClose.addEventListener('click', (e) => {
						e.stopPropagation();
						$header.classList.remove(a);
						$loginBtn.classList.remove(a);
						$loginContents.classList.remove(a);
					});
				}
				// 外側をクリックで閉じる
				document.addEventListener('click', (event) => {
					if ($loginBtn.classList.contains(a)) {
						const isClickInsideBtn = $loginBtn.contains(event.target);
						const isClickInsideContents = $loginContents.contains(event.target);
						if (!isClickInsideBtn && !isClickInsideContents) {
							$header.classList.remove(a);
							$loginBtn.classList.remove(a);
							$loginContents.classList.remove(a);
						}
					}
				});
				// フォーカスが外れた時の処理
				const checkAndCloseLogin = () => {
					setTimeout(() => {
						const focusedElement = document.activeElement;
						const isInsideBtn = $loginBtn.contains(focusedElement);
						const isInsideContents = $loginContents.contains(focusedElement);
						if (!isInsideBtn && !isInsideContents) {
							$header.classList.remove(a);
							$loginBtn.classList.remove(a);
							$loginContents.classList.remove(a);
						}
					}, 0);
				};
				// $loginBtn.addEventListener('focusout', checkAndCloseLogin);
				$loginContents.addEventListener('focusout', checkAndCloseLogin);
				// ESCキーで閉じる
				window.addEventListener('keydown', (event) => {
					if ($loginBtn.classList.contains(a) && event.key === 'Escape') {
						event.preventDefault();
						$header.classList.remove(a);
						$loginBtn.classList.remove(a);
						$loginContents.classList.remove(a);
					}
				});
			}
		},
		floatLink() {
			const $elm = document.querySelector('.footer-floatLink');
			const $btn = document.querySelector('.js-footer-floatLink-btn');
			const $contents = document.querySelector('.js-footer-floatLink-contents');
			const currentPath = location.pathname.replace(/index\.html$/, '');
			const hidePaths = ['/member/', '/notice/', '/notice/coin.html'];
			if ($elm && hidePaths.includes(currentPath)) {
				$elm.style.display = 'none';
				return;
			}
			if ($btn && $contents) {
				$btn.addEventListener('click', () => {
					const isActive = $btn.classList.contains(a);
					if (isActive) {
						$elm.classList.remove(a);
						$btn.classList.remove(a);
						$contents.classList.remove(a);
					} else {
						$elm.classList.add(a);
						$btn.classList.add(a);
						$contents.classList.add(a);
					}
				});
				// スクロール開始時にメニューを閉じる
				let isScrolling = false;
				window.addEventListener('scroll', () => {
					// メニューが開いている場合のみ処理
					if (!$btn.classList.contains(a) && !isScrolling) {
						isScrolling = true;
						$elm.classList.add(a);
						$btn.classList.add(a);
						$contents.classList.add(a);
						setTimeout(() => {
							isScrolling = false;
						}, 300);
					}
				});
			}
		},
		slider01() {
			const splides = document.querySelectorAll('.js-slider01');
			splides.forEach(slideElement => {
				const splide = new Splide(slideElement, {
					type: 'loop',
					autoplay: true,
					interval: 5000,
					speed: 2000,
					perPage: 3,
					perMove: 1,
					gap: '40px',
					pauseOnHover: true,
					pauseOnFocus: true,
					arrows: true,
					pagination: false,
					breakpoints: {
						1024: {
							perPage: 1,
							gap: '16px',
						},
					},
					classes: {
						arrows: 'splide__arrows mod-slider-arrows',
						arrow: 'splide__arrow mod-slider-arrow',
						prev: 'splide__arrow--prev mod-slider-prev',
						next: 'splide__arrow--next mod-slider-next'
					},
				});
				// 各スライダー内のインデックス表示要素を取得
				const currentElement = slideElement.querySelector('.slide-current');
				const lengthElement = slideElement.querySelector('.slide-length');
				function slideIndex() {
					if (currentElement && lengthElement) {
						// 複製を除いたオリジナルのスライド数を取得
						const slides = splide.Components.Slides.get();
						const originalSlides = slides.filter(slide => !slide.isClone);
						const totalOriginal = originalSlides.length;
						// 現在のインデックスを計算（複製の場合は対応するオリジナルのインデックスを取得）
						let currentIndex = splide.index;
						if (splide.Components.Slides.getAt(currentIndex).isClone) {
							currentIndex = splide.Components.Slides.getAt(currentIndex).slideIndex;
						}
						const current = String(currentIndex + 1).padStart(2, '0');
						const total = String(totalOriginal).padStart(2, '0');
						currentElement.textContent = current;
						lengthElement.textContent = total;
					}
				}
				splide.on('overflow', function (isOverflow) {
					splide.go(0);
					splide.options = {
						arrows : isOverflow,
						pagination: isOverflow,
						drag : isOverflow,
						clones : isOverflow ? undefined : 0,
					};
				});
				splide.on('move', slideIndex);
				splide.mount();
				slideIndex();
			});
		},
		pickupSlider() {
			const splides = document.querySelectorAll('.js-pickupSlider');
			splides.forEach(slideElement => {
				const splide = new Splide(slideElement, {
					type: 'loop',
					autoplay: true,
					interval: 5000,
					speed: 2000,
					perPage: 3,
					perMove: 1,
					gap: '40px',
					pauseOnHover: true,
					pauseOnFocus: true,
					arrows: true,
					pagination: false,
					breakpoints: {
						1024: {
							perPage: 1,
							gap: '16px',
						},
					},
					classes: {
						arrows: 'splide__arrows mod-slider-arrows',
						arrow: 'splide__arrow mod-slider-arrow',
						prev: 'splide__arrow--prev mod-slider-prev',
						next: 'splide__arrow--next mod-slider-next'
					},
				});
				// 各スライダー内のインデックス表示要素を取得
				const currentElement = slideElement.querySelector('.slide-current');
				const lengthElement = slideElement.querySelector('.slide-length');
				function slideIndex() {
					if (currentElement && lengthElement) {
						// 複製を除いたオリジナルのスライド数を取得
						const slides = splide.Components.Slides.get();
						const originalSlides = slides.filter(slide => !slide.isClone);
						const totalOriginal = originalSlides.length;
						// 現在のインデックスを計算（複製の場合は対応するオリジナルのインデックスを取得）
						let currentIndex = splide.index;
						if (splide.Components.Slides.getAt(currentIndex).isClone) {
							currentIndex = splide.Components.Slides.getAt(currentIndex).slideIndex;
						}
						const current = String(currentIndex + 1).padStart(2, '0');
						const total = String(totalOriginal).padStart(2, '0');
						currentElement.textContent = current;
						lengthElement.textContent = total;
					}
				}
				splide.on('overflow', function (isOverflow) {
					splide.go(0);
					splide.options = {
						arrows : isOverflow,
						pagination: isOverflow,
						drag : isOverflow,
						clones : isOverflow ? undefined : 0,
					};
				});
				splide.on('move', slideIndex);
				splide.mount();
				slideIndex();
			});
		},
		rewardSlider() {
			const splides = document.querySelectorAll('.js-rewardSlider');
			const _this = this;
			splides.forEach(slideElement => {
				const splide = new Splide(slideElement, {
					type: 'loop',
					autoplay: true,
					interval: 5000,
					speed: 2000,
					perPage: 4,
					perMove: 1,
					gap: '24px',
					pauseOnHover: true,
					pauseOnFocus: true,
					arrows: true,
					pagination: false,
					breakpoints: {
						1024: {
							perPage: 1,
							gap: '16px',
						},
					},
					classes: {
						arrows: 'splide__arrows mod-slider-arrows',
						arrow: 'splide__arrow mod-slider-arrow',
						prev: 'splide__arrow--prev mod-slider-prev',
						next: 'splide__arrow--next mod-slider-next'
					},
				});
				// 各スライダー内のインデックス表示要素を取得
				const currentElement = slideElement.querySelector('.slide-current');
				const lengthElement = slideElement.querySelector('.slide-length');
				function slideIndex() {
					if (currentElement && lengthElement) {
						// 複製を除いたオリジナルのスライド数を取得
						const slides = splide.Components.Slides.get();
						const originalSlides = slides.filter(slide => !slide.isClone);
						const totalOriginal = originalSlides.length;
						// 現在のインデックスを計算（複製の場合は対応するオリジナルのインデックスを取得）
						let currentIndex = splide.index;
						if (splide.Components.Slides.getAt(currentIndex).isClone) {
							currentIndex = splide.Components.Slides.getAt(currentIndex).slideIndex;
						}
						const current = String(currentIndex + 1).padStart(2, '0');
						const total = String(totalOriginal).padStart(2, '0');
						currentElement.textContent = current;
						lengthElement.textContent = total;
					}
				}
				splide.on('overflow', function (isOverflow) {
					splide.go(0);
					splide.options = {
						arrows : isOverflow,
						pagination: isOverflow,
						drag : isOverflow,
						clones : isOverflow ? undefined : 0,
					};
				});
				splide.on('move', slideIndex);
				splide.mount();
				slideIndex();
				// スライダーのマウント完了後にmatchHeightを実行
				setTimeout(() => {
					_this.matchHeight();
				}, 100);
			});
		},
		rewardLoopSlider() {
			const splides = document.querySelectorAll('.js-rewardLoopSlider');
			const _this = this;
			splides.forEach(slideElement => {
				const splide = new Splide(slideElement, {
					type: 'loop',
					autoWidth: true,
					fixedHeight: '30px',
					gap: '32px',
					pauseOnHover: false,
					pauseOnFocus: false,
					arrows: false,
					pagination: false,
					breakpoints: {
						1024: {
							fixedHeight: '20px',
							gap: '20px',
						},
					},
					autoScroll: {
						speed: .5,
						pauseOnHover: false,
						pauseOnFocus: false,
					}
				});
				splide.mount(window.splide.Extensions);
			});
		},
		/**
		 * モーダル動画（mod-modal-video）の特殊アスペクト比を初期化する。
		 * デフォルトの 16:9 はページ側のインラインスクリプトで初期化する想定。
		 * 拡張時はこの aspectMap にクラスと比率を追記するだけで全ページに反映される。
		 */
		modalVideo() {
			if (typeof ModalVideo === 'undefined') return;

			// クラス名 → ratio のマップ。新しい比率を追加する場合はここに追記する。
			const aspectMap = {
				'_aspect_938x750': '938:750'
			};

			const baseOptions = {
				channel: 'youtube',
				autoplay: 0,
				youtube: { autoplay: 0 }
			};

			Object.keys(aspectMap).forEach(cls => {
				const btns = document.querySelectorAll(`.js-modal-video.${cls}`);
				if (btns.length) {
					new ModalVideo(btns, Object.assign({}, baseOptions, { ratio: aspectMap[cls] }));
				}
			});

			// _aspect_* 付きボタン押下時の追加処理（document に1度だけ登録）：
			//   1. ライブラリが生成した .modal-video にも同じ _aspect_* クラスを付与（CSSフック）
			//   2. iframe の src が .mp4 の場合、cross-origin の制約でiframe内のvideoを
			//      スタイル制御できず黒縁が出るため、こちら側で <video> 要素に差し替える
			if (FUNCTIONS._modalVideoEnhanced) return;
			FUNCTIONS._modalVideoEnhanced = true;
			document.addEventListener('click', e => {
				const btn = e.target.closest('.js-modal-video');
				if (!btn) return;
				const aspectClass = Array.from(btn.classList).find(c => /^_aspect_\d+x\d+$/.test(c));
				if (!aspectClass) return;

				// ライブラリのクリックハンドラはバブリング中に同期的に modal を生成するため、
				// document レベル（バブリング後段）の本ハンドラ実行時には既に DOM 上に存在する。
				const modals = document.querySelectorAll('.modal-video');
				const modal = modals[modals.length - 1];
				if (!modal) return;

				modal.classList.add(aspectClass);

				// クラス名から比率を抽出して CSS 変数として設定。
				// _video.scss 側で aspect-ratio / max-width 計算に利用する。
				const m = aspectClass.match(/^_aspect_(\d+)x(\d+)$/);
				if (m) {
					modal.style.setProperty('--modal-aspect-ratio', `${m[1]} / ${m[2]}`);
					modal.style.setProperty('--modal-aspect-w', m[1]);
					modal.style.setProperty('--modal-aspect-h', m[2]);
				}

				const iframe = modal.querySelector('.modal-video-movie-wrap iframe');
				if (!iframe) return;
				const src = iframe.getAttribute('src') || '';
				if (!/\.mp4(\?|$)/i.test(src)) return;

				const video = document.createElement('video');
				video.src = src;
				video.controls = true;
				video.autoplay = true;
				video.playsInline = true;
				video.setAttribute('style', 'position:absolute;top:0;left:0;width:100%;height:100%;background:transparent;');
				iframe.parentNode.replaceChild(video, iframe);
			});
		},
		loadDelayScript() {
			let _this = this;
			_this.accordion();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.matchHeight();
			_this.inViewAnimation();
			_this.nextToggle();
			_this.moreView();
			_this.imgZoom();
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.URLcurrent();
			_this.pcHeaderMegamenu();
			_this.spHeaderHamburger();
			_this.headerLogin();
			_this.floatLink();
			_this.slider01();
			_this.pickupSlider();
			_this.rewardSlider();
			_this.rewardLoopSlider();
			_this.modalVideo();

			let resizeTime = 0;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
